// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/checkout-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/checkout-banner-2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VialHero_vialHero__du0TV {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: 'Aktive Grotesk Bold', sans-serif;
    width: 100%;
}
.VialHero_mainPanel__nALmv {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60%;
    margin-left: 20%;
    margin-right: 20%;
    padding-top: 5em;
}
.VialHero_bubble__b-I4M {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: white;
    background-color: lightgray;
    font-size: 42px;
    font-weight: 800;
    padding: 0.5em 1.25em;
    margin: 0 auto;
    border-top-left-radius: 1em;
    border-top-right-radius: 1em;
    position: relative;
    cursor: pointer;
}
.VialHero_dotWhack__fpERn {
    position: absolute;
    top: -4em;
    font-size: 18px;
    background: lightyellow;
    color: black;
    padding: 0.75em;
    border-radius: 3em;
    text-align: center;
    line-height: 1em;
}
.VialHero_dotWhackPercent__ch4ZX {
    font-size: 28px;
    font-weight: 800;
}
.VialHero_right__rmtfK {
    left: calc(55% - 0.75em);
}
.VialHero_left__f8z2e {
    right: 55%;
}
.VialHero_glowSemaglutide__j9Z1a {
    box-shadow: 0 0 30px #00ff00;
}
.VialHero_glowTirzepatide__qlZCj {
    box-shadow: 0 0 30px #00ffff;
}
.VialHero_bar__Gg35T {
    height: 15px;
    position: relative;
    background: #69bf4a;
}
.VialHero_price__Yv6Tq {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 250px;
    min-width: 120px;
    cursor: pointer;
    width: 50%;
    border-radius: 1em;
}
.VialHero_startingAt__LiXTf {
    font-family: 'Aktiv Grotesk', sans-serif;
    font-size: 24px;
    font-weight: 400;
    color: #808080;
    text-align: center;
    line-height: 1.5em;
    margin-top: 1em;

    div {
        text-align: center;
    }
}    
.VialHero_dollars__zs5tu {
    font-size: 60px;
    font-weight: 800;
    font-family: 'Cocon Bold', sans-serif;
    margin-top: 0.25em;

    sup {
        font-size: 24px;
    }

    span {
        font-size: 0.4em;
    }

}
.VialHero_sameActive__Pj3BH {
    font-family: 'Aktiv Grotesk', sans-serif;
    font-size: 16px;
    color: #808080;
    font-weight: 500;
    text-align: center;
    width: 100%;
    line-height: 1.6;
}
.VialHero_sameActive__Pj3BH sup {
    font-size: 0.75em;
}
.VialHero_oralMeds__OupU6 {
    font-size: 18px;
    width: 100%;
    text-align: center;
    font-weight: 800;
}
.VialHero_oralMeds__OupU6 span {
    color: #69bf4a;
}
.VialHero_higherDoses__I2LDQ {
    font-family: 'Aktiv Grotesk', sans-serif;
    font-size: 16px;
    color: #808080;
    font-weight: 500;
    text-align: center;
    width: 100%;
    margin-top: 0.5em;
}
.VialHero_semaglutide__M9KGQ, .VialHero_tirzepatide__V8Clo {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    position: relative;
}
.VialHero_medBar__5ha50 {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-left: 20%;
    margin-right: 20%;
}
.VialHero_yellow__MTw-0 {
    background: yellow;
}
.VialHero_semaBackground__ABj69 {
    background: #69bf4a;
}
.VialHero_tirzBackground__qJn4K {
    background: #21cec9;
}
.VialHero_semaBorder__pXMff {
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    border: 0.5em solid #69bf4a;
}
.VialHero_tirzBorder__zupZ6 {
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    border: 0.5em solid #21cec9;
}
.VialHero_semaPlanBorder__q58K9 {
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    border: 0.25em solid #69bf4a;
}
.VialHero_tirzPlanBorder__5Zbw7 {
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    border: 0.25em solid #21cec9;
}
.VialHero_planTitle__HjWnJ {
    width: 100%;
    text-align: center;
    color: white;
    border-top-left-radius: 0.4em;
    border-top-right-radius: 0.4em;
    font-size: 32px;
}
.VialHero_planAmount__aXZXE {
    width: calc(100% - 0.5em);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.VialHero_medPlans__KeZKI {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-start;
    gap: 0.25em;
    width: 100%;
}
.VialHero_medPlan__AabPJ {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    margin: 0 auto;
    width: 100%;
}
.VialHero_medPlanBox__Mlkud {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 5px;
    font-size: 18px;
    font-weight: 800;
    margin-top: 2em;
    margin-bottom: 1em;
}
.VialHero_medPlanImg__Ge72J {
    display: flex;
    flex-direction: row;
}
.VialHero_vialImg__dZJYa {
    width: 150px;
    margin: 0 0.5em;
}
.VialHero_weightLoss__69mya {
    width: 90%;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    display: flex;
    gap: 1em;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}
.VialHero_lossText__S119H {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 800;
    gap: 5px;
    width: 100%;
}
.VialHero_percent__jsH3y {
    font-size: 42px;
    font-weight: 800;

    sup {
        font-size: 15px;            
    }
}
.VialHero_dose__NMbrM {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: white;
}
.VialHero_plans__lzH0O {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 0 0.25em;
    gap: 0.25em;
}
.VialHero_ticks__r3Iwg {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    margin-top: 1em;
    padding-bottom: 4em;
    background: linear-gradient(to bottom, transparent, #d1fffd);
}
.VialHero_tick__1G9F4 {
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin: 0.5em;
    align-items: center;
    justify-content: center;
}
.VialHero_tickImg__Lvx0m {
    width: 20px;
}
.VialHero_tickText__LnHxc {
    font-size: 28px;
    font-weight: 800;
    vertical-align: text-bottom;
    text-align: center;
}
.VialHero_dagger__Be9Mk {
    font-size: 16px;
    font-weight: 800;
    text-align: center;
}
.VialHero_divider__j2PTB {
    width: 100%;
    height: 20px;
    background: #d1fffd;
}
.VialHero_dividerBar__ianju {
    position: relative;
    top: 10px;
    width: 90%;
    height: 20px;
    background: #69bf4a;
    margin: 0 auto;
    border-radius: 999px;
}
.VialHero_startMyJourney__pUK6s {
    background-color: transparent;
    text-align: center;
}

.VialHero_letsGo__MBd2\\+ {
    text-align: center;
    padding: 12px;
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Cocon Bold', sans-serif;
    cursor: pointer;
    margin-bottom: 0.5em;
}
.VialHero_buttonArrow__TjyBx {
    margin-left: 10px;
    width: 24px;
}
.VialHero_glow__xvI58 {
    box-shadow: 0 0 30px #00ff00;
}
.VialHero_banner__Tjg8- {
    width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: right;
    display: flex;
    align-items: end;
    position: relative;
    z-index: -1;
    height: 350px;
}
.VialHero_bannerText__duiwp {
    padding: 0 0 0 5%;
}
.VialHero_bannerSubtitle__76Z9N {
    font-size: 26px;
    font-weight: 700;
}
.VialHero_bannerTitle__B7s-6 {
    font-size: 100px;
    font-family: 'Cocon Bold', sans-serif;
    padding-bottom: 10px;
}
.VialHero_headerRule__-KoSQ {
    height: 10px;
    width: 90%;
    background-color: #69bf4a;
    position: absolute;
    left: 5%;
    bottom: -5px;
    border-radius: 999px;
}

@media screen and (max-width: 1400px) {

    .VialHero_mainPanel__nALmv {
        width: 70%;
        margin-left: 15%;
        margin-right: 15%;
        padding-top: 4em;
    }
    .VialHero_banner__Tjg8- {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        height: 170px;
        justify-content: center;
    }
    .VialHero_bannerTitle__B7s-6 {
        font-size: 60px;
    }
    .VialHero_dotWhack__fpERn {
        font-size: 14px;
    }
    .VialHero_dotWhackPercent__ch4ZX {
        font-size: 32px;
    }
    .VialHero_bubble__b-I4M {
        font-size: 36px;
        padding: 0.4em 1em;
    }
}

@media screen and (max-width: 925px) {
    .VialHero_mainPanel__nALmv {
        width: 80%;
        margin-left: 10%;
        margin-right: 10%;
    }
    .VialHero_left__f8z2e {
        right: 50%;
    }
    .VialHero_right__rmtfK {
        left: calc(50% - 0.75em);
    }
    .VialHero_vialImg__dZJYa {
        width: 120px;
    }
}

@media screen and (max-width: 850px) {
    .VialHero_mainPanel__nALmv {
        padding-top: 3em;
    }
    .VialHero_bubble__b-I4M {
        font-size: 32px;
        padding: 0.25em 0.75em;
    }
    .VialHero_startingAt__LiXTf {
        font-size: 20px;
    }    
    .VialHero_dollars__zs5tu {
        font-size: 42px;
    
        sup {
            font-size: 18px;
        }
    }
    .VialHero_dose__NMbrM {
        font-size: 12px;
    }
    .VialHero_planTitle__HjWnJ {
        font-size: 28px;
    }
    .VialHero_lossText__S119H {
        font-size: 14px;
    }
    .VialHero_dotWhack__fpERn {
        font-size: 12px;
        top: -3.5em;
    }
    .VialHero_dotWhackPercent__ch4ZX {
        font-size: 22px;
    }
    .VialHero_left__f8z2e {
        right: 55%;
    }
    .VialHero_right__rmtfK {
        left: calc(50% - 0.75em);
    }
    .VialHero_tick__1G9F4 {
        gap: 5px;
    }
    .VialHero_tickImg__Lvx0m {
        width: 18px;
    }
    .VialHero_tickText__LnHxc {
        font-size: 20px;
        line-height: 1em;
    }
    .VialHero_divider__j2PTB {
        height: 14px;
    }
    .VialHero_dividerBar__ianju {
        top: 7px;
        height: 14px;
    }
    .VialHero_headerRule__-KoSQ {
        height: 7px;
        bottom: -3px;
    }
    .VialHero_sameActive__Pj3BH {
        font-size: 14px;
    }
    .VialHero_oralMeds__OupU6 {
        font-size: 16px;
    }
    .VialHero_letsGo__MBd2\\+ {
        padding: 12px;
        font-size: 18px;
        margin-bottom: 0.5em;
    }
}
@media screen and (max-width: 682px) {
    .VialHero_vialImg__dZJYa {
        width: 90px;
    }
    .VialHero_bubble__b-I4M {
        font-size: 28px;
    }
    .VialHero_startingAt__LiXTf {
        font-size: 16px;
    }     
    .VialHero_dollars__zs5tu {
        font-size: 28px;
    }
    .VialHero_sameActive__Pj3BH, .VialHero_higherDoses__I2LDQ {
        font-size: 12px;
    }
    .VialHero_weightLoss__69mya {
        width: 100%;
    }
    .VialHero_lossText__S119H {
        font-size: 12px;
    }
    .VialHero_percent__jsH3y {
        font-size: 32px;

        sup {
            font-size: 12px;            
        }
    }
    .VialHero_dotWhack__fpERn {
        font-size: 10px;
    }
    .VialHero_dotWhackPercent__ch4ZX {
        font-size: 22px;
    }
    .VialHero_left__f8z2e {
        right: 55%;
    }
    .VialHero_right__rmtfK {
        left: calc(55% - 0.75em);
    }
    .VialHero_ticks__r3Iwg {
        margin-top: 1em;
    }
    .VialHero_tick__1G9F4 {
        margin: 0.4em;
        /* div {
            font-size: 14px;
        } */
    }
    .VialHero_tickText__LnHxc {
        font-size: 14px;
    }
    .VialHero_divider__j2PTB {
        height: 10px;
    }
    .VialHero_dividerBar__ianju {
        top: 5px;
        height: 10px;
    }
    .VialHero_letsGo__MBd2\\+ {
        padding: 12px;
        font-size: 18px;
        margin: 0.5em;
    }
    .VialHero_buttonArrow__TjyBx {
        margin-left: 10px;
        width: 20px;
    }
    .VialHero_planTitle__HjWnJ {
        font-size: 22px;    
    }
}
@media screen and (max-width: 580px) {
    .VialHero_banner__Tjg8- {
        height: 160px;
    }
    .VialHero_bannerTitle__B7s-6 {
        font-size: 48px;
    }
    .VialHero_bannerSubtitle__76Z9N {
        font-size: 24px;
    }
    .VialHero_mainPanel__nALmv {
        width: 90%;
        margin-left: 5%;
        margin-right: 5%;
    }
    .VialHero_letsGo__MBd2\\+ {
        padding: 8px;
        font-size: 16px;
        margin-bottom: 0.5em;
    }
    .VialHero_dose__NMbrM {
        font-size: 10px;
    }
    .VialHero_vialImg__dZJYa {
        width: 70px;
    }
    .VialHero_bubble__b-I4M {
        font-size: 24px;
        padding: 0.4em 0.75em;
    }
    .VialHero_oralMeds__OupU6 {
        font-size: 14px;
    }
}
@media screen and (max-width: 512px) {
    .VialHero_bannerTitle__B7s-6 {
        font-size: 42px;
    }
    .VialHero_bannerSubtitle__76Z9N {
        font-size: 20px;
    }
    .VialHero_mainPanel__nALmv {
        padding-top: 2.5em;
    }
    .VialHero_bubble__b-I4M {
        font-size: 20px;
        padding: 0.4em 0.75em;
    }
    .VialHero_vialImg__dZJYa {
        width: 60px;
    }
    .VialHero_planTitle__HjWnJ {
        font-size: 18px;
    }
    .VialHero_startingAt__LiXTf {
        font-size: 12px;
    }
    .VialHero_sameActive__Pj3BH, .VialHero_higherDoses__I2LDQ {
        font-size: 10px;
    }
    .VialHero_dotWhack__fpERn {
        font-size: 8px;
        top: -4em;
    }
    .VialHero_dotWhackPercent__ch4ZX {
        font-size: 16px;
    }
    .VialHero_letsGo__MBd2\\+ {
        padding: 8px;
        font-size: 14px;
    }
    .VialHero_buttonArrow__TjyBx {
        margin-left: 10px;
        width: 16px;
    }
    .VialHero_medPlanBox__Mlkud {
        margin-top: 1em;
        margin-bottom: 0.5em;
    }
}
@media screen and (max-width: 438px) {
    .VialHero_medPlanBox__Mlkud {
        padding: 0.25em;
        gap: 0px;
    }
    .VialHero_dollars__zs5tu {
        font-size: 24px;
    }
    .VialHero_letsGo__MBd2\\+ {
        padding: 6px;
        font-size: 12px;
    }
    .VialHero_buttonArrow__TjyBx {
        margin-left: 8px;
        width: 12px;
    }
    .VialHero_price__Yv6Tq {
        font-size: 12px;
        min-width: 100px;
    }
    .VialHero_oralMeds__OupU6 {
        font-size: 12px;
    }
}
@media screen and (max-width: 360px){
    .VialHero_banner__Tjg8- {
        height: 130px;
    }
    .VialHero_bannerTitle__B7s-6 {
        font-size: 24px;
    }
    .VialHero_bannerSubtitle__76Z9N {
        font-size: 16px;
    }

    .VialHero_mainPanel__nALmv {
        width: 98%;
        margin: 0 auto;
    }
    .VialHero_bubble__b-I4M {
        font-size: 16px;
    }
    .VialHero_sameActive__Pj3BH, .VialHero_higherDoses__I2LDQ {
        font-size: 9px;
    }
    .VialHero_planTitle__HjWnJ {
        font-size: 16px;
    }
    .VialHero_dollars__zs5tu {
        font-size: 22px;
        padding: 0;
    }
    .VialHero_percent__jsH3y {
        font-size: 28px;

        sup {
            font-size: 12px;            
        }
    }
    .VialHero_lossText__S119H {
        font-size: 10px;
    }
    .VialHero_ticks__r3Iwg {
        padding-bottom: 2em;
    }
    .VialHero_divider__j2PTB {
        height: 8px;
    }
    .VialHero_dividerBar__ianju {
        top: 4px;
        height: 8px;
    }
    .VialHero_medPlanBox__Mlkud {
        margin-bottom: 0;
        margin-top: 0.5em;
    }
    .VialHero_oralMeds__OupU6 {
        font-size: 10px;
    }
}
@media screen and (max-width: 332px){
    .VialHero_mainPanel__nALmv {
        padding-top: 1em;
    }
    .VialHero_dotWhack__fpERn {
        font-size: 6px;
        top: -4em;
    }
    .VialHero_dotWhackPercent__ch4ZX {
        font-size: 12px;
    }
    .VialHero_bubble__b-I4M {
        font-size: 16px;
        padding: 0.4em 0.5em;
        max-width: 100px;
    }
    .VialHero_startingAt__LiXTf {
        font-size: 10px;
    }
    .VialHero_dose__NMbrM {
        font-size: 8px;
    }
    .VialHero_price__Yv6Tq {
        font-size: 10px;
        min-width: none;
    }
    .VialHero_lossText__S119H {
        font-size: 10px;
    }
    .VialHero_percent__jsH3y {
        font-size: 20px;

        sup {
            font-size: 10px;            
        }
    }
    .VialHero_tick__1G9F4 {
        margin: 0.25em;
        gap: 2px;
    }
    .VialHero_tickImg__Lvx0m {
        width: 15px;
    }
    .VialHero_tickText__LnHxc {
        font-size: 12px;
    }
    .VialHero_vialImg__dZJYa {
        width: 40px;
    }
}

@media screen and (max-width: 308px){
    .VialHero_vialImg__dZJYa {
        width: 50px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Landing/VialHero.module.css"],"names":[],"mappings":"AAAA;IAGI,aAAa;IAIL,sBAAsB;IAGtB,uBAAuB;IAGvB,mBAAmB;IAC3B,8CAA8C;IAC9C,WAAW;AACf;AACA;IAGI,aAAa;IAIL,sBAAsB;IAGtB,uBAAuB;IAGvB,mBAAmB;IAC3B,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IAGI,aAAa;IAIL,mBAAmB;IAGnB,uBAAuB;IAGvB,mBAAmB;IAC3B,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,UAAU;AACd;AACA;IAEY,4BAA4B;AACxC;AACA;IAEY,4BAA4B;AACxC;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IAGI,aAAa;IAIL,sBAAsB;IAGtB,uBAAuB;IAGvB,mBAAmB;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;;IAEf;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;;IAElB;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;AAEJ;AACA;IACI,wCAAwC;IACxC,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,wCAAwC;IACxC,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;AACA;IAGI,aAAa;IAIL,sBAAsB;IAGtB,8BAA8B;IACtC,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,cAAc;IAGd,aAAa;IAIL,mBAAmB;IAGnB,uBAAuB;IAGvB,8BAA8B;IACtC,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,2BAA2B;AAC/B;AACA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,2BAA2B;AAC/B;AACA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,4BAA4B;AAChC;AACA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,yBAAyB;IAGzB,aAAa;IAIL,sBAAsB;IAGtB,uBAAuB;IAGvB,mBAAmB;AAC/B;AACA;IAGI,aAAa;IAIL,mBAAmB;IAGnB,6BAA6B;IAG7B,uBAAuB;IAC/B,WAAW;IACX,WAAW;AACf;AACA;IAGI,aAAa;IAIL,sBAAsB;IAGtB,6BAA6B;IAG7B,mBAAmB;IAC3B,cAAc;IACd,WAAW;AACf;AACA;IAGI,aAAa;IAIL,mBAAmB;IAGnB,uBAAuB;IAGvB,uBAAuB;IAC/B,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IAGI,aAAa;IAIL,mBAAmB;AAC/B;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IAGpB,aAAa;IACb,QAAQ;IAIA,sBAAsB;IAGtB,uBAAuB;IAGvB,uBAAuB;AACnC;AACA;IAGI,aAAa;IAIL,mBAAmB;IAGnB,mBAAmB;IAGnB,uBAAuB;IAC/B,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;;IAEhB;QACI,eAAe;IACnB;AACJ;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;AACA;IAGI,aAAa;IAIL,mBAAmB;IAGnB,6BAA6B;IAG7B,uBAAuB;IAC/B,gBAAgB;IAChB,WAAW;AACf;AACA;IAGI,aAAa;IAIL,sBAAsB;IAGtB,uBAAuB;IAC/B,WAAW;IACX,cAAc;IACd,eAAe;IACf,mBAAmB;IAGnB,4DAA4D;AAChE;AACA;IAGI,aAAa;IAIL,mBAAmB;IAC3B,SAAS;IACT,aAAa;IAGL,mBAAmB;IAGnB,uBAAuB;AACnC;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IAGnB,aAAa;IAGL,mBAAmB;IAGnB,uBAAuB;IAC/B,qCAAqC;IACrC,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,WAAW;AACf;AACA;IAEY,4BAA4B;AACxC;AACA;IACI,WAAW;IACX,yDAAuD;IACvD,sBAAsB;IACtB,0BAA0B;IAG1B,aAAa;IAGL,gBAAgB;IACxB,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,oBAAoB;AACxB;;AAEA;;IAEI;QACI,UAAU;QACV,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,yDAAyD;QACzD,aAAa;QAGL,uBAAuB;IACnC;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,UAAU;IACd;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;;QAEf;YACI,eAAe;QACnB;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,QAAQ;IACZ;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,QAAQ;QACR,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;QACb,eAAe;QACf,oBAAoB;IACxB;AACJ;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;;QAEf;YACI,eAAe;QACnB;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;QACb;;WAEG;IACP;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,QAAQ;QACR,YAAY;IAChB;IACA;QACI,aAAa;QACb,eAAe;QACf,aAAa;IACjB;IACA;QACI,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,qBAAqB;IACzB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,qBAAqB;IACzB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;QACd,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;AACJ;AACA;IACI;QACI,eAAe;QACf,QAAQ;IACZ;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,UAAU;IACd;IACA;QACI,eAAe;;QAEf;YACI,eAAe;QACnB;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,QAAQ;QACR,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,oBAAoB;QACpB,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;;QAEf;YACI,eAAe;QACnB;IACJ;IACA;QACI,cAAc;QACd,QAAQ;IACZ;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".vialHero {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    font-family: 'Aktive Grotesk Bold', sans-serif;\n    width: 100%;\n}\n.mainPanel {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 60%;\n    margin-left: 20%;\n    margin-right: 20%;\n    padding-top: 5em;\n}\n.bubble {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    color: white;\n    background-color: lightgray;\n    font-size: 42px;\n    font-weight: 800;\n    padding: 0.5em 1.25em;\n    margin: 0 auto;\n    border-top-left-radius: 1em;\n    border-top-right-radius: 1em;\n    position: relative;\n    cursor: pointer;\n}\n.dotWhack {\n    position: absolute;\n    top: -4em;\n    font-size: 18px;\n    background: lightyellow;\n    color: black;\n    padding: 0.75em;\n    border-radius: 3em;\n    text-align: center;\n    line-height: 1em;\n}\n.dotWhackPercent {\n    font-size: 28px;\n    font-weight: 800;\n}\n.right {\n    left: calc(55% - 0.75em);\n}\n.left {\n    right: 55%;\n}\n.glowSemaglutide {\n    -webkit-box-shadow: 0 0 30px #00ff00;\n            box-shadow: 0 0 30px #00ff00;\n}\n.glowTirzepatide {\n    -webkit-box-shadow: 0 0 30px #00ffff;\n            box-shadow: 0 0 30px #00ffff;\n}\n.bar {\n    height: 15px;\n    position: relative;\n    background: #69bf4a;\n}\n.price {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    max-width: 250px;\n    min-width: 120px;\n    cursor: pointer;\n    width: 50%;\n    border-radius: 1em;\n}\n.startingAt {\n    font-family: 'Aktiv Grotesk', sans-serif;\n    font-size: 24px;\n    font-weight: 400;\n    color: #808080;\n    text-align: center;\n    line-height: 1.5em;\n    margin-top: 1em;\n\n    div {\n        text-align: center;\n    }\n}    \n.dollars {\n    font-size: 60px;\n    font-weight: 800;\n    font-family: 'Cocon Bold', sans-serif;\n    margin-top: 0.25em;\n\n    sup {\n        font-size: 24px;\n    }\n\n    span {\n        font-size: 0.4em;\n    }\n\n}\n.sameActive {\n    font-family: 'Aktiv Grotesk', sans-serif;\n    font-size: 16px;\n    color: #808080;\n    font-weight: 500;\n    text-align: center;\n    width: 100%;\n    line-height: 1.6;\n}\n.sameActive sup {\n    font-size: 0.75em;\n}\n.oralMeds {\n    font-size: 18px;\n    width: 100%;\n    text-align: center;\n    font-weight: 800;\n}\n.oralMeds span {\n    color: #69bf4a;\n}\n.higherDoses {\n    font-family: 'Aktiv Grotesk', sans-serif;\n    font-size: 16px;\n    color: #808080;\n    font-weight: 500;\n    text-align: center;\n    width: 100%;\n    margin-top: 0.5em;\n}\n.semaglutide, .tirzepatide {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    text-align: center;\n    position: relative;\n}\n.medBar {\n    width: 100%;\n    margin: 0 auto;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    margin-left: 20%;\n    margin-right: 20%;\n}\n.yellow {\n    background: yellow;\n}\n.semaBackground {\n    background: #69bf4a;\n}\n.tirzBackground {\n    background: #21cec9;\n}\n.semaBorder {\n    border-bottom-left-radius: 1em;\n    border-bottom-right-radius: 1em;\n    border: 0.5em solid #69bf4a;\n}\n.tirzBorder {\n    border-bottom-left-radius: 1em;\n    border-bottom-right-radius: 1em;\n    border: 0.5em solid #21cec9;\n}\n.semaPlanBorder {\n    border-bottom-left-radius: 1em;\n    border-bottom-right-radius: 1em;\n    border: 0.25em solid #69bf4a;\n}\n.tirzPlanBorder {\n    border-bottom-left-radius: 1em;\n    border-bottom-right-radius: 1em;\n    border: 0.25em solid #21cec9;\n}\n.planTitle {\n    width: 100%;\n    text-align: center;\n    color: white;\n    border-top-left-radius: 0.4em;\n    border-top-right-radius: 0.4em;\n    font-size: 32px;\n}\n.planAmount {\n    width: calc(100% - 0.5em);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.medPlans {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-pack: space-evenly;\n        -ms-flex-pack: space-evenly;\n            justify-content: space-evenly;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    gap: 0.25em;\n    width: 100%;\n}\n.medPlan {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: space-evenly;\n        -ms-flex-pack: space-evenly;\n            justify-content: space-evenly;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin: 0 auto;\n    width: 100%;\n}\n.medPlanBox {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    gap: 5px;\n    font-size: 18px;\n    font-weight: 800;\n    margin-top: 2em;\n    margin-bottom: 1em;\n}\n.medPlanImg {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n}\n.vialImg {\n    width: 150px;\n    margin: 0 0.5em;\n}\n.weightLoss {\n    width: 90%;\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    gap: 1em;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n}\n.lossText {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    font-size: 18px;\n    font-weight: 800;\n    gap: 5px;\n    width: 100%;\n}\n.percent {\n    font-size: 42px;\n    font-weight: 800;\n\n    sup {\n        font-size: 15px;            \n    }\n}\n.dose {\n    text-align: center;\n    font-size: 18px;\n    font-weight: 500;\n    color: white;\n}\n.plans {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-pack: space-evenly;\n        -ms-flex-pack: space-evenly;\n            justify-content: space-evenly;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    margin: 0 0.25em;\n    gap: 0.25em;\n}\n.ticks {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    width: 100%;\n    margin: 0 auto;\n    margin-top: 1em;\n    padding-bottom: 4em;\n    background: -webkit-gradient(linear, left top, left bottom, from(transparent), to(#d1fffd));\n    background: -o-linear-gradient(top, transparent, #d1fffd);\n    background: linear-gradient(to bottom, transparent, #d1fffd);\n}\n.tick {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    gap: 10px;\n    margin: 0.5em;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.tickImg {\n    width: 20px;\n}\n.tickText {\n    font-size: 28px;\n    font-weight: 800;\n    vertical-align: text-bottom;\n    text-align: center;\n}\n.dagger {\n    font-size: 16px;\n    font-weight: 800;\n    text-align: center;\n}\n.divider {\n    width: 100%;\n    height: 20px;\n    background: #d1fffd;\n}\n.dividerBar {\n    position: relative;\n    top: 10px;\n    width: 90%;\n    height: 20px;\n    background: #69bf4a;\n    margin: 0 auto;\n    border-radius: 999px;\n}\n.startMyJourney {\n    background-color: transparent;\n    text-align: center;\n}\n\n.letsGo {\n    text-align: center;\n    padding: 12px;\n    color: #fff;\n    font-weight: bold;\n    font-size: 24px;\n    border-radius: 25px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    font-family: 'Cocon Bold', sans-serif;\n    cursor: pointer;\n    margin-bottom: 0.5em;\n}\n.buttonArrow {\n    margin-left: 10px;\n    width: 24px;\n}\n.glow {\n    -webkit-box-shadow: 0 0 30px #00ff00;\n            box-shadow: 0 0 30px #00ff00;\n}\n.banner {\n    width: 100%;\n    background-image: url(../../assets/checkout-banner.png);\n    background-size: cover;\n    background-position: right;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: end;\n    position: relative;\n    z-index: -1;\n    height: 350px;\n}\n.bannerText {\n    padding: 0 0 0 5%;\n}\n.bannerSubtitle {\n    font-size: 26px;\n    font-weight: 700;\n}\n.bannerTitle {\n    font-size: 100px;\n    font-family: 'Cocon Bold', sans-serif;\n    padding-bottom: 10px;\n}\n.headerRule {\n    height: 10px;\n    width: 90%;\n    background-color: #69bf4a;\n    position: absolute;\n    left: 5%;\n    bottom: -5px;\n    border-radius: 999px;\n}\n\n@media screen and (max-width: 1400px) {\n\n    .mainPanel {\n        width: 70%;\n        margin-left: 15%;\n        margin-right: 15%;\n        padding-top: 4em;\n    }\n    .banner {\n        background-image: url(../../assets/checkout-banner-2.png);\n        height: 170px;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n    }\n    .bannerTitle {\n        font-size: 60px;\n    }\n    .dotWhack {\n        font-size: 14px;\n    }\n    .dotWhackPercent {\n        font-size: 32px;\n    }\n    .bubble {\n        font-size: 36px;\n        padding: 0.4em 1em;\n    }\n}\n\n@media screen and (max-width: 925px) {\n    .mainPanel {\n        width: 80%;\n        margin-left: 10%;\n        margin-right: 10%;\n    }\n    .left {\n        right: 50%;\n    }\n    .right {\n        left: calc(50% - 0.75em);\n    }\n    .vialImg {\n        width: 120px;\n    }\n}\n\n@media screen and (max-width: 850px) {\n    .mainPanel {\n        padding-top: 3em;\n    }\n    .bubble {\n        font-size: 32px;\n        padding: 0.25em 0.75em;\n    }\n    .startingAt {\n        font-size: 20px;\n    }    \n    .dollars {\n        font-size: 42px;\n    \n        sup {\n            font-size: 18px;\n        }\n    }\n    .dose {\n        font-size: 12px;\n    }\n    .planTitle {\n        font-size: 28px;\n    }\n    .lossText {\n        font-size: 14px;\n    }\n    .dotWhack {\n        font-size: 12px;\n        top: -3.5em;\n    }\n    .dotWhackPercent {\n        font-size: 22px;\n    }\n    .left {\n        right: 55%;\n    }\n    .right {\n        left: calc(50% - 0.75em);\n    }\n    .tick {\n        gap: 5px;\n    }\n    .tickImg {\n        width: 18px;\n    }\n    .tickText {\n        font-size: 20px;\n        line-height: 1em;\n    }\n    .divider {\n        height: 14px;\n    }\n    .dividerBar {\n        top: 7px;\n        height: 14px;\n    }\n    .headerRule {\n        height: 7px;\n        bottom: -3px;\n    }\n    .sameActive {\n        font-size: 14px;\n    }\n    .oralMeds {\n        font-size: 16px;\n    }\n    .letsGo {\n        padding: 12px;\n        font-size: 18px;\n        margin-bottom: 0.5em;\n    }\n}\n@media screen and (max-width: 682px) {\n    .vialImg {\n        width: 90px;\n    }\n    .bubble {\n        font-size: 28px;\n    }\n    .startingAt {\n        font-size: 16px;\n    }     \n    .dollars {\n        font-size: 28px;\n    }\n    .sameActive, .higherDoses {\n        font-size: 12px;\n    }\n    .weightLoss {\n        width: 100%;\n    }\n    .lossText {\n        font-size: 12px;\n    }\n    .percent {\n        font-size: 32px;\n\n        sup {\n            font-size: 12px;            \n        }\n    }\n    .dotWhack {\n        font-size: 10px;\n    }\n    .dotWhackPercent {\n        font-size: 22px;\n    }\n    .left {\n        right: 55%;\n    }\n    .right {\n        left: calc(55% - 0.75em);\n    }\n    .ticks {\n        margin-top: 1em;\n    }\n    .tick {\n        margin: 0.4em;\n        /* div {\n            font-size: 14px;\n        } */\n    }\n    .tickText {\n        font-size: 14px;\n    }\n    .divider {\n        height: 10px;\n    }\n    .dividerBar {\n        top: 5px;\n        height: 10px;\n    }\n    .letsGo {\n        padding: 12px;\n        font-size: 18px;\n        margin: 0.5em;\n    }\n    .buttonArrow {\n        margin-left: 10px;\n        width: 20px;\n    }\n    .planTitle {\n        font-size: 22px;    \n    }\n}\n@media screen and (max-width: 580px) {\n    .banner {\n        height: 160px;\n    }\n    .bannerTitle {\n        font-size: 48px;\n    }\n    .bannerSubtitle {\n        font-size: 24px;\n    }\n    .mainPanel {\n        width: 90%;\n        margin-left: 5%;\n        margin-right: 5%;\n    }\n    .letsGo {\n        padding: 8px;\n        font-size: 16px;\n        margin-bottom: 0.5em;\n    }\n    .dose {\n        font-size: 10px;\n    }\n    .vialImg {\n        width: 70px;\n    }\n    .bubble {\n        font-size: 24px;\n        padding: 0.4em 0.75em;\n    }\n    .oralMeds {\n        font-size: 14px;\n    }\n}\n@media screen and (max-width: 512px) {\n    .bannerTitle {\n        font-size: 42px;\n    }\n    .bannerSubtitle {\n        font-size: 20px;\n    }\n    .mainPanel {\n        padding-top: 2.5em;\n    }\n    .bubble {\n        font-size: 20px;\n        padding: 0.4em 0.75em;\n    }\n    .vialImg {\n        width: 60px;\n    }\n    .planTitle {\n        font-size: 18px;\n    }\n    .startingAt {\n        font-size: 12px;\n    }\n    .sameActive, .higherDoses {\n        font-size: 10px;\n    }\n    .dotWhack {\n        font-size: 8px;\n        top: -4em;\n    }\n    .dotWhackPercent {\n        font-size: 16px;\n    }\n    .letsGo {\n        padding: 8px;\n        font-size: 14px;\n    }\n    .buttonArrow {\n        margin-left: 10px;\n        width: 16px;\n    }\n    .medPlanBox {\n        margin-top: 1em;\n        margin-bottom: 0.5em;\n    }\n}\n@media screen and (max-width: 438px) {\n    .medPlanBox {\n        padding: 0.25em;\n        gap: 0px;\n    }\n    .dollars {\n        font-size: 24px;\n    }\n    .letsGo {\n        padding: 6px;\n        font-size: 12px;\n    }\n    .buttonArrow {\n        margin-left: 8px;\n        width: 12px;\n    }\n    .price {\n        font-size: 12px;\n        min-width: 100px;\n    }\n    .oralMeds {\n        font-size: 12px;\n    }\n}\n@media screen and (max-width: 360px){\n    .banner {\n        height: 130px;\n    }\n    .bannerTitle {\n        font-size: 24px;\n    }\n    .bannerSubtitle {\n        font-size: 16px;\n    }\n\n    .mainPanel {\n        width: 98%;\n        margin: 0 auto;\n    }\n    .bubble {\n        font-size: 16px;\n    }\n    .sameActive, .higherDoses {\n        font-size: 9px;\n    }\n    .planTitle {\n        font-size: 16px;\n    }\n    .dollars {\n        font-size: 22px;\n        padding: 0;\n    }\n    .percent {\n        font-size: 28px;\n\n        sup {\n            font-size: 12px;            \n        }\n    }\n    .lossText {\n        font-size: 10px;\n    }\n    .ticks {\n        padding-bottom: 2em;\n    }\n    .divider {\n        height: 8px;\n    }\n    .dividerBar {\n        top: 4px;\n        height: 8px;\n    }\n    .medPlanBox {\n        margin-bottom: 0;\n        margin-top: 0.5em;\n    }\n    .oralMeds {\n        font-size: 10px;\n    }\n}\n@media screen and (max-width: 332px){\n    .mainPanel {\n        padding-top: 1em;\n    }\n    .dotWhack {\n        font-size: 6px;\n        top: -4em;\n    }\n    .dotWhackPercent {\n        font-size: 12px;\n    }\n    .bubble {\n        font-size: 16px;\n        padding: 0.4em 0.5em;\n        max-width: 100px;\n    }\n    .startingAt {\n        font-size: 10px;\n    }\n    .dose {\n        font-size: 8px;\n    }\n    .price {\n        font-size: 10px;\n        min-width: none;\n    }\n    .lossText {\n        font-size: 10px;\n    }\n    .percent {\n        font-size: 20px;\n\n        sup {\n            font-size: 10px;            \n        }\n    }\n    .tick {\n        margin: 0.25em;\n        gap: 2px;\n    }\n    .tickImg {\n        width: 15px;\n    }\n    .tickText {\n        font-size: 12px;\n    }\n    .vialImg {\n        width: 40px;\n    }\n}\n\n@media screen and (max-width: 308px){\n    .vialImg {\n        width: 50px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vialHero": `VialHero_vialHero__du0TV`,
	"mainPanel": `VialHero_mainPanel__nALmv`,
	"bubble": `VialHero_bubble__b-I4M`,
	"dotWhack": `VialHero_dotWhack__fpERn`,
	"dotWhackPercent": `VialHero_dotWhackPercent__ch4ZX`,
	"right": `VialHero_right__rmtfK`,
	"left": `VialHero_left__f8z2e`,
	"glowSemaglutide": `VialHero_glowSemaglutide__j9Z1a`,
	"glowTirzepatide": `VialHero_glowTirzepatide__qlZCj`,
	"bar": `VialHero_bar__Gg35T`,
	"price": `VialHero_price__Yv6Tq`,
	"startingAt": `VialHero_startingAt__LiXTf`,
	"dollars": `VialHero_dollars__zs5tu`,
	"sameActive": `VialHero_sameActive__Pj3BH`,
	"oralMeds": `VialHero_oralMeds__OupU6`,
	"higherDoses": `VialHero_higherDoses__I2LDQ`,
	"semaglutide": `VialHero_semaglutide__M9KGQ`,
	"tirzepatide": `VialHero_tirzepatide__V8Clo`,
	"medBar": `VialHero_medBar__5ha50`,
	"yellow": `VialHero_yellow__MTw-0`,
	"semaBackground": `VialHero_semaBackground__ABj69`,
	"tirzBackground": `VialHero_tirzBackground__qJn4K`,
	"semaBorder": `VialHero_semaBorder__pXMff`,
	"tirzBorder": `VialHero_tirzBorder__zupZ6`,
	"semaPlanBorder": `VialHero_semaPlanBorder__q58K9`,
	"tirzPlanBorder": `VialHero_tirzPlanBorder__5Zbw7`,
	"planTitle": `VialHero_planTitle__HjWnJ`,
	"planAmount": `VialHero_planAmount__aXZXE`,
	"medPlans": `VialHero_medPlans__KeZKI`,
	"medPlan": `VialHero_medPlan__AabPJ`,
	"medPlanBox": `VialHero_medPlanBox__Mlkud`,
	"medPlanImg": `VialHero_medPlanImg__Ge72J`,
	"vialImg": `VialHero_vialImg__dZJYa`,
	"weightLoss": `VialHero_weightLoss__69mya`,
	"lossText": `VialHero_lossText__S119H`,
	"percent": `VialHero_percent__jsH3y`,
	"dose": `VialHero_dose__NMbrM`,
	"plans": `VialHero_plans__lzH0O`,
	"ticks": `VialHero_ticks__r3Iwg`,
	"tick": `VialHero_tick__1G9F4`,
	"tickImg": `VialHero_tickImg__Lvx0m`,
	"tickText": `VialHero_tickText__LnHxc`,
	"dagger": `VialHero_dagger__Be9Mk`,
	"divider": `VialHero_divider__j2PTB`,
	"dividerBar": `VialHero_dividerBar__ianju`,
	"startMyJourney": `VialHero_startMyJourney__pUK6s`,
	"letsGo": `VialHero_letsGo__MBd2+`,
	"buttonArrow": `VialHero_buttonArrow__TjyBx`,
	"glow": `VialHero_glow__xvI58`,
	"banner": `VialHero_banner__Tjg8-`,
	"bannerText": `VialHero_bannerText__duiwp`,
	"bannerSubtitle": `VialHero_bannerSubtitle__76Z9N`,
	"bannerTitle": `VialHero_bannerTitle__B7s-6`,
	"headerRule": `VialHero_headerRule__-KoSQ`
};
export default ___CSS_LOADER_EXPORT___;
